// src/constants/skills.constants.js
export const SKILLS_TITLE = 'My Skills';
export const SKILLS_HEADER = 'what i know';
export const SKILLS_PARA_HEADER = 'My skills & experiences';
export const SKILLS_PARA_TEXT1 = 'I have over 5 years of experience in developing full stack applications.';
export const SKILLS_PARA_SKILLSET1_KEY = 'Frontend Skills :';
export const SKILLS_PARA_SKILLSET1_VALUE =
  'JavaScript, TypeScript, ReactJs, Redux, NextJs, CSS3, React Native, ElectronJS, HTML5, Material Ui, Bootstrap, and SASS.';
export const SKILLS_PARA_SKILLSET2_KEY = 'Backend Skills :';
export const SKILLS_PARA_SKILLSET2_VALUE = 'Node Js, Express Js, Next Js, MongoDb, PostgreSQL.';
export const SKILLS_PARA_SKILLSET3_KEY = 'Cloud and other services skill :';
export const SKILLS_PARA_SKILLSET3_VALUE = 'GRPC, Docker, and AWS.';
export const GITHUB_BUTTON_TEXT = 'Visit My GitHub Profile';
export const GITHUB_HREF = 'https://github.com/mihirshah2752';
export const SKILLS_SET = [
  {
    name: SKILLS_PARA_SKILLSET1_KEY,
    value: SKILLS_PARA_SKILLSET1_VALUE,
  },
  {
    name: SKILLS_PARA_SKILLSET2_KEY,
    value: SKILLS_PARA_SKILLSET2_VALUE,
  },
  {
    name: SKILLS_PARA_SKILLSET3_KEY,
    value: SKILLS_PARA_SKILLSET3_VALUE,
  },
];
